/* The provenance banner. It sits above the KPIs because the number underneath
   it means something different depending on which measurement produced it —
   and a reader who scrolls past it has already read the headline. */
.basis {
  display: flex;
  align-items: baseline;
  gap: 10px;
  width: var(--table-w);
  max-width: 100%;
  padding: 9px 14px;
  border: 1px solid var(--border-cell);
  border-left-width: 3px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 17px;
}

.basis strong {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* Partner truth reads calm; an estimate reads as a caveat. */
.basisActual {
  border-left-color: #1f7a45;
  background: #f4fbf6;
  color: #2c5d3f;
}
.basisEstimate {
  border-left-color: #d8b23f;
  background: #fffdf4;
  color: #5d5326;
}

/* Gainers beside decliners: the pair is one thought and reads worse stacked. */
.split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--table-gap);
  width: var(--table-w);
  max-width: 100%;
}
.split > section { width: auto; }

@media (max-width: 1180px) {
  .split { grid-template-columns: 1fr; }
}
